export default __webpack_public_path__ + "static/media/5.40782e49.jpeg";